import { Container } from "@/_di/types";
import { createContainer, InjectionMode } from "awilix";

export const container = createContainer<Container>({
  injectionMode: InjectionMode.PROXY,
});
